import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box, TextField, Button } from "@mui/material";
import { toast } from "react-toastify";
import { updateStockKae } from "../../../../services";
import LaeButton from "../../../../components/Buttons/LaeButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60ch",
  maxHeight: "80vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const EditarStockProducto = ({ opened, stock, almacenId, handleClose }) => {
  const { t } = useTranslation(["common"]);
  const [formData, setFormData] = useState({
    cantidad: 0,
    stock_minimo: 0,
    stock_maximo: 0,
  });

  useEffect(() => {
    if (opened && stock) {
      setFormData({
        cantidad: stock.cantidad ?? 0,
        stock_minimo: stock.stock_minimo ?? 0,
        stock_maximo: stock.stock_maximo ?? 0,
      });
    }
  }, [opened, stock]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: Number(e.target.value),
    });
  };

  const handleSubmit = async () => {
    const toastInfo = toast.info(t("almacenes.messages.saving"), { autoClose: false });
    try {
      await updateStockKae({
        producto_id: stock.id,
        almacen_id: almacenId,
        cantidad: formData.cantidad,
        stock_minimo: formData.stock_minimo,
        stock_maximo: formData.stock_maximo,
      });
      toast.update(toastInfo, {
        render: t("almacenes.messages.editedSuccess"),
        type: toast.TYPE.SUCCESS,
        autoClose: true,
      });
      handleClose();
    } catch (err) {
      console.log(err);
      toast.update(toastInfo, {
        render: t("almacenes.messages.editError"),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
  };

  if (!stock) return null;

  return (
    <Modal
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      open={opened}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Box sx={style}>
        <div style={{ padding: "16px 32px 24px" }}>
          <h2>{t("almacenes.messages.editStock")}</h2>
          <p style={{ fontWeight: "bold", fontSize: "14px", paddingBottom: 16 }}>
            {stock.nombre} - ({stock.sku})
          </p>
          <Box display="flex" flexDirection="row" gap={2} mb={3}>
            <TextField
              fullWidth
              type="number"
              label={t("almacenes.stock.quantity")}
              variant="outlined"
              name="cantidad"
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              value={formData.cantidad}
              inputProps={{ min: 0 }}
            />
            <TextField
              fullWidth
              type="number"
              label={t("almacenes.stock.minimum")}
              variant="outlined"
              name="stock_minimo"
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              value={formData.stock_minimo}
              inputProps={{ min: 0 }}
            />
            <TextField
              fullWidth
              type="number"
              label={t("almacenes.stock.maximum")}
              variant="outlined"
              name="stock_maximo"
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              value={formData.stock_maximo}
              inputProps={{ min: 0 }}
            />
          </Box>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gridGap: "15px",
              fontSize: "12px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "whitesmoke",
                color: "#92004D",
                ":hover": { backgroundColor: "#92004D", color: "white" },
                p: 1,
              }}
              disableElevation
              onClick={handleClose}
            >
              {t("actions.cancel")}
            </Button>
            <LaeButton onClick={handleSubmit}>
              {t("actions.save")}
            </LaeButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default EditarStockProducto;
